import { render, staticRenderFns } from "./AssignStatusModal.vue?vue&type=template&id=57d48975&"
import script from "./AssignStatusModal.vue?vue&type=script&lang=js&"
export * from "./AssignStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports